<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-md-1"> </div>
      <div id="doc" class="col-xs-12 col-md-10 content-body mt-2"  v-html="docHtml">
      </div>
      <div class="col-xs-12 col-md-1"> </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import marked from 'marked'
  // import docStr from  'raw-loader!./assets/privacy-policy.md'

  let docSrc = `
## プライバシーポリシー
　株式会社イワテシガ（以下「弊社」という）は、「新元号.jp」をご利用される方（以下「利用者」という）の個人情報の重要性を認識し、常にその保護に細心の注意を払い措置を講じます。

### 個人情報の利用目的
　個人情報とは、個人の氏名、住所、電話番号、メールアドレス等を指します。この個人情報は利用者の本人確認、料金の請求、弊社サービスの提供及び広告宣伝のために利用します。

### 個人情報の目的外利用及び第三者提供の制限
　弊社は「個人情報の利用目的」に記載された範囲に限り個人情報を取り扱います。この個人情報は利用者ご本人の同意がない限り第三者に提供することはありません。ただし、「個人情報の保護に関する法律」第23条に該当する場合はこの限りではありません。

### 個人情報の取得
　弊社は、利用者から適正な手続きにより個人情報を取得し、その際、利用者の同意を必ず得るものとします。なお、個人情報を取得する際には、利用目的を利用者にあらかじめ通知または公表します。

### 個人情報の保護
　弊社は、利用者の個人情報が正確かつ最新のものであるよう努め、安全に管理する必要かつ適切な措置を講じます。

### 個人情報の開示
　弊社は、利用者ご本人からご自身の個人情報の開示を求められた場合は遅滞なく通知します。ただし、「個人情報の保護に関する法律」第24条に該当する場合はこの限りではありません。

### Cookie（クッキー）の利用について
　弊社が運用するWebサイトでは、アクセス解析及びマーケティングを目的としたサードパーティのツールを導入するために、Cookieを使用しています。

　Cookieとは、Webサイトにアクセスした際に、少量のデータをブラウザに送信する仕組みです。利用者が繰り返しWebサイトに訪問した際に、効率よくサービスを利用するための仕組みです。利用者ご本人は、インターネット閲覧ソフトウェアの設定によりクッキーの受け取りを拒否することもできます。

#### アクセス解析ツールについて
　弊社が運営するWebサイトでは、その利用状況を把握するために、サードパーティであるGoogle社が提供するGoogleアナリティクスを利用しています。Googleアナリティクスは、Cookieを用いて弊社のサイトへのアクセスを個人を特定することなく収集しています。Googleアナリティクスにおけるアクセス情報の収集の仕方及びその利用方針については、Googleのプライバシーポリシーをご覧ください。

- Google社のプライバシーポリシー
  - https://policies.google.com/privacy

#### SNSのボタン等について
　弊社が運営するWebサイトの一部において、情報の伝達・共有を目的として、サードパーティが提供する「ボタン」が埋め込まれることがあります。これらの「ボタン」等は、ページが表示されただけでWebサイトからSNSに対し、ユーザーID及びアクセスしているサイトのURL等の情報が自動送信されていることがあります。それらSNSにおける情報の収集と利用方針に関しては、下記のポリシーをご覧ください。
- Facebook社のデータに関するポリシー
  - https://www.facebook.com/privacy/explanation
- Twitter社のプライバシーポリシー
  - https://twitter.com/privacy?lang=ja
- Google社のプライバシーポリシー
  - https://policies.google.com/privacy

### 法令・規範の遵守
　弊社は、このプライバシーポリシーに記載されていない事項につきましても個人情報保護に関連する法令及びその他規範を遵守し、対処します。

### プライバシーポリシーに関するお問い合わせ先
　個人情報に関するお問い合わせ・ご質問は、contact&#64;r4hs.com までメール送信をお願いします。

- 改訂日：令和元年年5月1日     
`;

export default {
    data: () => {
      let docHtml = marked(docSrc, { sanitize: false });
      return  {
        docHtml
      }
    },
    name: 'privacy_policy',
    components:{
    }
  };
</script>

<style>
.content-body {
  background-color: #fcfcfc;
  text-align: left;
  font-size: smaller;
  padding: 2em;
}
</style>
